import { Box, Button, Paper, SvgIconTypeMap, Tooltip, Typography } from '@mui/material';
import React from 'react';
import SortComponent from './SortComponent';
import { AddCircleOutline } from '@mui/icons-material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { useAuth } from '../../context/authContext';


interface ViewTableHeaderProps {
    title: string;
    icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
    handleAdd: (event: React.MouseEvent<HTMLButtonElement>) => void;
    addText: string;
    sortColumn?: string;
    setSortColumn?: React.Dispatch<React.SetStateAction<string>>;
    sortDirection?: boolean;
    setSortDirection?: React.Dispatch<React.SetStateAction<boolean>>;
    sortValues?: { value: string, label: string }[];
    allowAdd?: boolean;
    showSort?: boolean;
}

const ViewTableHeader: React.FC<ViewTableHeaderProps> = ({
    title,
    icon,
    handleAdd,
    addText,
    sortColumn,
    setSortColumn,
    sortDirection,
    setSortDirection,
    sortValues,
    allowAdd = true,
    showSort = true
}) => {
    return (
        <Paper elevation={3} sx={{overflow: 'auto', mb: 2, padding: 2, borderRadius: 3, display: 'flex', justifyContent: 'space-between'}}>
        <Box color='primary.main' sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', }}>
            {React.createElement(icon, { sx: { mr: 1, height: 40, width: 40 } })}
            <Typography variant="h5">{title}</Typography>
        </Box>
        <Box sx={showSort ? {display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '50%'} : {}}>
            {showSort && <SortComponent 
                sortColumn={sortColumn || 'created_on'}
                setSortColumn={setSortColumn || (() => {})}
                sortDirection={sortDirection || false}
                setSortDirection={setSortDirection || (() => {})}
                sortValues={sortValues || []}
            />}
            {allowAdd && <Tooltip title={addText}>
                <Button variant="contained" color="primary" onClick={handleAdd}>{addText}<AddCircleOutline sx={{ml:1}} /></Button>
            </Tooltip>}
        </Box>
    </Paper>
    );
}

export default ViewTableHeader;